<template>
  <StandardCard
    v-bind="attrs"
    :card-text-style="collapsed ? { display: 'none' } : undefined"
    :divided="!collapsed"
    :title="title"
    :title-action-cols="resolvedTitleActionCols"
    class="standard-collapse-card"
  >
    <template #titleAction>
      <div class="d-flex align-center ga-2">
        <slot name="titleActionExtra" />

        <StandardButton
          @click="toggle"
          v-bind="collapseTitleAction"
        />
      </div>
    </template>

    <template
      v-if="$slots.title"
      #title
    >
      <slot name="title" />
    </template>

    <template
      v-if="$slots.subtitle"
      #subtitle
    >
      <slot name="subtitle" />
    </template>

    <template
      v-if="$slots['title-prepend']"
      #title-prepend
    >
      <slot name="title-prepend" />
    </template>

    <template
      v-if="$slots['title-append']"
      #title-append
    >
      <slot name="title-append" />
    </template>

    <template
      v-if="$slots.actions"
      #actions
    >
      <slot name="actions" />
    </template>

    <slot />
  </StandardCard>
</template>

<script setup>
import { useSlots } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  sectionName: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: null,
  },
  titleActionCols: {
    type: [Number, String],
    default: null,
  },
});

const collapsed = defineModel('collapsed', {
  type: Boolean,
  default: false,
});

const attrs = useAttrs();
const slots = useSlots();

const hasTitleActionExtra = computed(() => Boolean(slots.titleActionExtra));

const sectionLabel = computed(() => props.sectionName ?? props.title ?? 'Section');

const collapseTitleAction = computed(() => ({
  ariaLabel: collapsed.value
    ? `Expand ${sectionLabel.value} section`
    : `Collapse ${sectionLabel.value} section`,
  color: 'grey',
  icon: collapsed.value ? 'chevron_left' : 'expand_more',
  preventDoubleClick: false,
  size: 'x-small',
  variant: 'flat',
}));

const resolvedTitleActionCols = computed(() => {
  if (props.titleActionCols != null) {
    return props.titleActionCols;
  }

  if (hasTitleActionExtra.value) {
    return 5;
  }

  return undefined;
});

function toggle() {
  collapsed.value = !collapsed.value;
}
</script>
